import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Section } from 'foundations-components/transitional/components/Section';
import HelpfulButton from 'marketplace-ui-reviews/components/HelpfulButton';
import Rating from 'marketplace-ui-reviews/components/Rating';
import ReportButton from 'marketplace-ui-reviews/components/ReportButton';
import ReviewActionsWrapper from 'marketplace-ui-reviews/components/ReviewActionsWrapper';
import ReviewBody from 'marketplace-ui-reviews/components/ReviewBody';
import ReviewEditToggle from 'marketplace-ui-reviews/components/ReviewEditToggle';
import ReviewReplyThread from 'marketplace-ui-reviews/components/ReviewReplyThread';
import ReviewTranslationToggle from 'marketplace-ui-reviews/components/ReviewTranslationToggle';
import ReviewerInfo from 'marketplace-ui-reviews/components/ReviewerInfo';
import { RatingAxes } from 'marketplace-ui-reviews/constants/RatingAxes';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ReviewRenderer({
  borderBottom,
  review,
  searchTerm,
  reviewType,
  onTrackInteraction
}) {
  // TODO: replace with actual logic
  const isInApp = true;
  const [showOriginal, setShowOriginal] = useState(false);
  const [showUntranslatedText, setShowUntranslatedText] = useState(false);
  const showReviewEditToggle = review.get('lastEditedAt') && review.get('original').ratings.get('OVERALL') !== review.get('ratings').get('OVERALL');
  const ratingValue = showOriginal ? review.get('original').ratings.get(RatingAxes.OVERALL) : review.ratings.get(RatingAxes.OVERALL);

  // TODO: include userMarkedHelpful state logic
  const helpfulCount = review.getHelpfulCount();
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    paddingBlock: "800",
    borderBlockEndStyle: borderBottom ? 'solid' : undefined,
    borderBlockEndWidth: borderBottom ? '100' : undefined,
    borderBlockEndColor: borderBottom ? 'border-core-subtle' : undefined,
    children: [/*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(Rating, {
        direction: "column",
        label: /*#__PURE__*/_jsxs(List, {
          inline: true,
          use: "inline-divided",
          children: [/*#__PURE__*/_jsx(FormattedDateTime, {
            value: review.get('createdAt'),
            format: "ll",
            type: "userTz"
          }), review.get('lastEditedAt') && /*#__PURE__*/_jsxs(View, {
            as: "span",
            marginInlineStart: "100",
            children: [/*#__PURE__*/_jsx(View, {
              as: "span",
              marginInlineEnd: "100",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-ui-reviews.edit.edited"
              })
            }), /*#__PURE__*/_jsx(FormattedDateTime, {
              value: review.get('lastEditedAt'),
              format: "ll",
              type: "userTz"
            })]
          })]
        }),
        rating: ratingValue,
        showTextRating: true
      })
    }), /*#__PURE__*/_jsx(ReviewBody, {
      review: review,
      searchTerm: searchTerm,
      showOriginal: showOriginal,
      showUntranslatedText: showUntranslatedText,
      reviewType: reviewType,
      onTrackInteraction: onTrackInteraction
    }), /*#__PURE__*/_jsx(ReviewerInfo, {
      review: review,
      inline: true
    }), /*#__PURE__*/_jsxs(ReviewActionsWrapper, {
      itemRight: /*#__PURE__*/_jsx(ReviewTranslationToggle, {
        review: review,
        onTrackInteraction: onTrackInteraction,
        showUntranslatedText: showUntranslatedText,
        setShowUntranslatedText: setShowUntranslatedText
      }),
      children: [/*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(HelpfulButton, {
          disabled: !isInApp,
          helpfulCount: helpfulCount,
          onClickHelpful: () => Promise.resolve()
          // TODO: replace with userMarkedHelpful state logic
          ,
          userMarkedHelpful: false
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(ReportButton, {
          isCustomer: isInApp,
          onClick: () => {}
        })
      }), showReviewEditToggle && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(ReviewEditToggle, {
          review: review,
          showOriginal: showOriginal,
          setShowOriginal: setShowOriginal
        })
      })]
    }), /*#__PURE__*/_jsx(ReviewReplyThread, {
      reply: review.getReply(showUntranslatedText),
      onReportReplyClick: () => {}
    })]
  });
}